import "@/App.css";
import PixelBoard from "@/PixelBoard";

function App() {
  return (
    <div className="App">
      <PixelBoard />
    </div>
  );
}

export default App;
